import VueRouter from 'vue-router';

import { PrivateRoutes, PRIVATE_ROUTES } from '@/app/private/private.routes';
import { PublicRoutes, PUBLIC_ROUTES } from '@/app/public/public.routes';
import { AuthProvider } from '@/auth/providers/auth.provider';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { LocalStorageService } from '@/services/local-storage.service';

export const CORE_ROUTES = {
  ...PRIVATE_ROUTES,
  PUBLIC: PUBLIC_ROUTES,
  PRIVATE: PRIVATE_ROUTES
};

export const routes = [
  { 
    path: '*',
    redirect: { 
      name: '404' 
    }
  },
  { 
    path: '/404',
    name: '404',
    component: () => import(/* NotFound */'@/app/commons/errors/not-found/not-found.view.vue')
  },
  { 
    path: '/403',
    name: '403',
    component: () => import(/* NotFound */'@/app/commons/errors/not-permissions/not-permissions.view.vue')
  },
  PublicRoutes,
  PrivateRoutes,
   // TO DO: The next lines have to be removed after the concept test around the designer is done.
  {
    path: '/designer',
    component: () => import(/* DesignerView */'@/app/public/designer/designer.view.vue'),
    name: 'public.designer'
  },
  { 
    path: '/index.html',
    redirect: to => {
      const lastRoute = LocalStorageService.getItem('lastRoute') || '/p/portal';
      return { path: lastRoute };
    }
  },
];

export const coreRouter = new VueRouter({ 
  base: process.env.VUE_APP_CONTEXT,
  mode: 'history',
  routes,
});

coreRouter.beforeEach((to, from, next) => {
  const accessToken = LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);
  const isTokenActive = AuthProvider.getIsTokenActive(accessToken);
  LocalStorageService.setItem('lastRoute', to.path);
  if(to.path.includes('/p/')) {
    if(isTokenActive) {
      next();
    } else {
      next({ name: PUBLIC_ROUTES.HOME.NAME });
    }
  } else {
    if(to.path.includes('home')) {
      if(isTokenActive) {
        next({ name: PRIVATE_ROUTES.HOME.NAME });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
